import styled, { createGlobalStyle } from "styled-components";

export const GlobalStyles = createGlobalStyle`
  #root {
    z-index: 1000;
  }
`;

export const VideoActions = styled("div")`
  position: absolute;
  z-index: -1;
  top: 10px;
  width: 100%;
  height: 100%;
  opacity: 0;
  transition: all 0.3s ease-in-out;
  background: rgb(0, 0, 0);
  background: linear-gradient(0deg, rgba(0, 0, 0, 1) 0%, rgba(0, 0, 0, 0) 100%);

  &.visible {
    top: 0%;
    opacity: 1;
    z-index: 1;
  }
`;

export const Title = styled("div")`
  padding: 20px;
  color: white;
`;

export const VideoWrapper = styled("div")`
  overflow: hidden;
  padding-bottom: 4px;

  &.fullscreen {
    position: fixed;
    z-index: 1000;
    top: 0;
    left: 0;
    height: 100%;
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    background: black;
  }
`;

export const VideoFrame = styled("div")`
  position: relative;
`;

export const ProgressBar = styled.div`
  position: absolute;
  bottom: 0;
  left: 0px;
  right: 0;
  height: 5px;
  background-color: rgba(255, 255, 255, 0.3);
`;

export const Progress = styled("div")<{ progress }>`
  height: 100%;
  width: ${({ progress }) => progress}%;

  position: absolute;
  z-index: 10;
  left: 0;
  top: 0;
  background-color: red;
`;

export const Bottom = styled("div")<{ progress }>`
  position: absolute;
  z-index: 10;
  top: 50%;
  left: ${({ progress }) => progress}%;
  width: 12px;
  height: 12px;
  border-radius: 50%;
  background-color: red;
  transform: translate(-50%, -50%);
`;

export const BufferedProgress = styled("div")<{ bufferedProgress }>`
  position: absolute;
  z-index: 5;
  left: 0;
  top: 0;
  height: 100%;
  width: ${({ bufferedProgress }) => bufferedProgress}%;
  background-color: #fff;
  opacity: 0.6;
`;

export const Play = styled("button")`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  background: none;
  border: 0px;
  border-radius: 100%;
  width: 80px;
  height: 80px;
  padding: 0;
`;

export const Screen = styled("button")`
  position: absolute;
  bottom: 10px;
  right: 20px;
  transform: translate(-50%, -50%);
  background: none;
  border: 0px;
  width: 24px;
  height: 24px;
  padding: 0;
`;

export const Volume = styled("button")`
  position: absolute;
  bottom: 10px;
  right: 60px;
  transform: translate(-50%, -50%);
  background: none;
  border: 0px;
  width: 24px;
  height: 24px;
  padding: 0;
`;

export const Timer = styled("div")`
  position: absolute;
  bottom: 10px;
  left: 60px;
  transform: translate(-50%, -50%);
  background: none;
  border: 0px;
  color: white;
  line-height: 24px;
`;
